import { ChangeDetectionStrategy, Component, computed, inject, OnInit, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridOptions, GridEmitter, UiGridComponent } from '@program-suite/ui-grid';
import { ButtonComponent } from '@program-suite/ui';
import { DocumentGridRowViewModel, LookupStore, ViewSubmissionStore } from '@program-suite/data-common';
import { ActivatedRoute } from '@angular/router';
import { ModalService, ModalType, FileUploadComponent, ConfirmationComponent } from '@program-suite/ui';
import { AuthStore } from '@program-suite/data-auth';
@Component({
  selector: 'lib-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss', '../view-submission.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    UiGridComponent,
    ButtonComponent
  ],
})
export class DocumentsComponent implements OnInit {
  viewSubmissionStore = inject(ViewSubmissionStore);
  lookupStore = inject(LookupStore);
  authStore = inject(AuthStore);
  changeTabEvent = output<string>();
  pageSizeMax = 2147483647;
  id: string | null = null;
  baseUrl: string = '';
  isPolicyPage: boolean = false;
  data = computed<DocumentGridRowViewModel[]>(() => this.viewSubmissionStore.documents?.() ?? []);
  filterValues = signal<any>({pageSize: this.pageSizeMax, sortOrder: {active: 'createdDate', direction: 'desc'}});
  gridOptions = signal<GridOptions>(
    {
      filterData: [],
      filterValues: this.filterValues,
      openFilters: true,
      columns: [
        { header: 'Created', controlName: 'createdDate', displayPipe: 'date'},
        { header: 'Type', controlName: 'documentType'},
        { header: 'File Name', controlName: 'name'},
        { header: 'Created By', controlName: 'createdBy'},
        { header: 'Manage', controlName: 'action', 
          actionColumnitems: [
            { type: 'icon', buttonAction: 'action',
              conditionalDisplay: { calculateDisplay: () => 'download', column: 'FileName' },
            },
            // LossRunProcessor can attach documents but not delete them
            ...(this.authStore.isLossRunProcessor() ? [] : [
              { type: 'icon' as const, buttonAction: 'delete',
                conditionalDisplay: { calculateDisplay: () => 'trash', column: 'FileName' },
                disableOnColumnValue: { column: 'canDelete', values: [false] },
              },
            ]),
          ]
        }
      ],
      data: this.data,
      frontEndPagination: true,
      fetchData: false,
      displaySearch: false,
      hidepagination: true,
    }
  );

  constructor(
    private route: ActivatedRoute,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.baseUrl = `${this.route.snapshot.url[0].path}`;
    this.isPolicyPage = this.baseUrl =='policies';
    this.lookupStore.loadLookup('documentType');
  }

  fetchAll(rawParams?: any) {
    this.viewSubmissionStore.getSubmissionDocuments(this.id ?? '', this.isPolicyPage);
  }

  fileUpload() {
    this.modalService.open(FileUploadComponent, {
      modalType: ModalType.Small,
      data: { 
        title: 'File Upload',
        subTitle: `${this.viewSubmissionStore.summary?.()?.businessInfo?.businessName} | ${this.viewSubmissionStore.summary?.()?.submissionNumber ?? 'N/A'}`,
        acceptedFormats: ['PDF', 'XLSX', 'CSV', 'DOCX', 'JPG', 'PNG'],
        fileTypes: this.lookupStore.documentType
      },

    }, (data?: any) => {
      if (data) {
        const formData = new FormData();
        for (let i = 0; i < data.files.length; i++) {
          formData.append('files', data.files[i]);
        }
        formData.append('documentType', data.documentType);
        formData.append('guid', this.id ?? '');
        this.viewSubmissionStore.uploadSubmissionDocument(formData, this.isPolicyPage);
      }
    });
  }

  deleteDocument(document: DocumentGridRowViewModel) {
    this.modalService.open(ConfirmationComponent, {modalType: ModalType.Medium}, (event) => {
      if (event) {
        this.viewSubmissionStore.deleteSubmissionDocument(document);
        this.viewSubmissionStore.getSubmissionDocuments(this.id ?? '', this.isPolicyPage);
      }
    })
  }

  actionEvent(event: GridEmitter) {
    if (event.action === 'fetchAll') {
      this.fetchAll(event.data);
    } else if (event.action === 'formChanges') {
      // this.fetchAll(event.data);
    } else if (event.action === 'clearFilters') {
      // this.fetchAll(event.data);
    } else if (event.action === 'onDestroy') {
      // on Destroy
    } else if (event.action === 'action') {
      //@ts-ignore
      this.viewSubmissionStore.downloadDocument(event.data?.id, event.data?.documentType == 'Policy' || event.data?.documentType == 'Submission');
    } else if (event.action === 'delete') {
      //@ts-ignore
      this.deleteDocument(event.data);    
    }
  }
}
